export enum QueryType {
  MANAGER = 'MANAGER',
  MY_REQUEST = 'MY_REQUEST',
  HR = 'HR',
}
